<!-- MODAL Pedidos -->
<div mdbModal #pedidos="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Pedidos
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="pedidos.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col mb-1" style="display: flex; justify-content: flex-end;">
                        <div class="leyenda mr-3">
                            <mdb-icon fas icon="circle" class="text-success"></mdb-icon><span> Atendible</span>
                        </div>
                        <div class="leyenda mr-3">
                            <mdb-icon fas icon="circle" class="text-danger"></mdb-icon><span> Quiebre</span>
                        </div>
                        <div class="leyenda">
                            <mdb-icon fas icon="circle" class="text-warning"></mdb-icon><span> Atendible
                                Parcialmente</span>
                        </div>
                    </div>
                </div>



                <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

                <div class="table-responsive" *ngIf="listaMovimientos">

                    <app-no-data-alert *ngIf="listaMovimientos?.length === 0">
                    </app-no-data-alert>

                    <table class="table table-striped table-hover table-sm align-middle"
                        *ngIf="listaMovimientos?.length > 0">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col" class="text-center">Nota de venta</th>
                                <th scope="col" class="text-center">Cliente</th>
                                <th scope="col" class="text-center">RUT</th>
                                <th scope="col" class="text-center">Cantidad</th>
                                <th scope="col" class="text-center">Estado</th>
                                <th scope="col" class="text-center">No atendible</th>
                                <th scope="col" class="text-center">Vendedor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let movimiento of listaMovimientos">
                                <td class="text-center">{{movimiento.documento_no_tributario_folio}}</td>
                                <td class="text-center">{{movimiento.nombrecliente}}</td>
                                <td class="text-center">{{movimiento.rutFormato | rut}}</td>
                                <td class="text-center">{{movimiento.cantidad_requerida | numerico}}</td>
                                <td class="text-center">
                                    <mdb-icon fas icon="circle" class="text-success"
                                        *ngIf="movimiento.estadocodigo === 0"></mdb-icon>
                                    <!-- Quiebre con algo atendido => Atendible Parcialmente (amarillo) -->
                                    <mdb-icon fas icon="circle" class="text-warning"
                                        *ngIf="movimiento.estadocodigo === 3 && movimiento.diferencia_con_stock < movimiento.cantidad_requerida"></mdb-icon>
                                    <!-- Quiebre total: nada atendido (rojo) -->
                                    <mdb-icon fas icon="circle" class="text-danger"
                                        *ngIf="movimiento.estadocodigo === 3 && movimiento.diferencia_con_stock >= movimiento.cantidad_requerida"></mdb-icon>
                                    <mdb-icon fas icon="circle" class="text-warning"
                                        *ngIf="movimiento.estadocodigo === 1"></mdb-icon>
                                </td>
                                <td class="text-center">{{ movimiento.diferencia_con_stock}}</td>
                                <td class="text-center">{{movimiento.nombreVendedor}}</td>
                            </tr>
                        </tbody>
                        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                            *ngIf="listaMovimientos?.length > 0"></app-pagination>
                    </table>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="pedidos.hide()"
                    mdbWavesEffect>
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>
